import { ThemeConstellation, ThemeSkunkWorks, FONT_TYPES } from "@zillow/constellation";
const ThemeCmsConstellation = {
  ...ThemeConstellation,
  constellation: {
    ...ThemeConstellation.constellation,
    colors: {
      ...ThemeConstellation.constellation.colors,
      backgroundBlack: ThemeConstellation.constellation.colors.black,
      backgroundBrand: ThemeConstellation.constellation.colors.blue400,
      backgroundDarkPurple: ThemeConstellation.constellation.colors.purple600,
      backgroundMedium: ThemeConstellation.constellation.colors.coolGray200,
      backgroundTeal: "#136F65",
      teal100: "#C8FBF2",
      teal200: "#9EF9EA",
      teal300: "#59F0DC",
      teal400: "#2DCFBC",
      teal500: "#21A495",
      teal600: "#136F65",
      textAqua: ThemeConstellation.constellation.colors.aqua300,
      textBrand: ThemeConstellation.constellation.colors.blue400,
      textDarkBlue: ThemeConstellation.constellation.colors.blue600,
      textDarkOrange: ThemeConstellation.constellation.colors.orange600,
      textDarkPurple: ThemeConstellation.constellation.colors.purple500,
      textGreen: ThemeConstellation.constellation.colors.green300,
      textOrange: ThemeConstellation.constellation.colors.orange300,
      textPurple: ThemeConstellation.constellation.colors.purple300,
      textTeal: "#136F65"
    },
    fontSizes: {
      ...ThemeConstellation.constellation.fontSizes,
      large: ThemeConstellation.constellation.fontSizes[FONT_TYPES.h5]
    },
    fontWeights: {
      ...ThemeConstellation.constellation.fontWeights,
      large: ThemeConstellation.constellation.fontWeights[FONT_TYPES.body]
    },
    lineHeights: {
      ...ThemeConstellation.constellation.lineHeights,
      large: ThemeConstellation.constellation.lineHeights[FONT_TYPES.h5]
    },
    spacing: {
      ...ThemeConstellation.constellation.spacing,
      xxl: 64,
      xxxl: 80
    },
    radii: {
      ...ThemeConstellation.constellation.radii,
      xl: 16,
      xxl: 24
    }
  }
};
const ThemeSkunkWorksCmsConstellation = {
  ...ThemeSkunkWorks,
  constellation: {
    ...ThemeSkunkWorks.constellation,
    colors: {
      ...ThemeSkunkWorks.constellation.colors,
      backgroundBlack: ThemeSkunkWorks.constellation.colors.black,
      backgroundBrand: ThemeSkunkWorks.constellation.colors.blue400,
      backgroundDarkPurple: ThemeSkunkWorks.constellation.colors.purple600,
      backgroundMedium: ThemeSkunkWorks.constellation.colors.coolGray200,
      backgroundTeal: "#136F65",
      teal100: "#C8FBF2",
      teal200: "#9EF9EA",
      teal300: "#59F0DC",
      teal400: "#2DCFBC",
      teal500: "#21A495",
      teal600: "#136F65",
      textAqua: ThemeSkunkWorks.constellation.colors.aqua300,
      textBrand: ThemeSkunkWorks.constellation.colors.blue400,
      textDarkBlue: ThemeSkunkWorks.constellation.colors.blue600,
      textDarkOrange: ThemeSkunkWorks.constellation.colors.orange600,
      textDarkPurple: ThemeSkunkWorks.constellation.colors.purple500,
      textGreen: ThemeSkunkWorks.constellation.colors.green300,
      textOrange: ThemeSkunkWorks.constellation.colors.orange300,
      textPurple: ThemeSkunkWorks.constellation.colors.purple300,
      textTeal: "#136F65"
    },
    fontSizes: {
      ...ThemeSkunkWorks.constellation.fontSizes,
      large: 18
    },
    fontWeights: {
      ...ThemeSkunkWorks.constellation.fontWeights,
      large: ThemeSkunkWorks.constellation.fontWeights[FONT_TYPES.body]
    },
    lineHeights: {
      ...ThemeSkunkWorks.constellation.lineHeights,
      large: ThemeSkunkWorks.constellation.lineHeights[FONT_TYPES.h5]
    },
    spacing: {
      ...ThemeSkunkWorks.constellation.spacing,
      xxl: 64,
      xxxl: 80
    },
    radii: {
      ...ThemeSkunkWorks.constellation.radii,
      xl: 16,
      xxl: 24
    }
  }
};
export {
  ThemeSkunkWorksCmsConstellation,
  ThemeCmsConstellation as default
};
